import { useMuxSpecificationApi } from "../../../common/api/orders-api/mux-specification/useMuxSpecificationApi";

export const useAdminMuxSpecificationApi = () => {
    const { getMuxSpecificationList, getMuxSpecificationsLookup, getMuxSpecificationById } = useMuxSpecificationApi();

    return {
        getMuxSpecificationList,
        getMuxSpecificationsLookup,
        getMuxSpecificationById
    };
};
